import { render, staticRenderFns } from "./bottomMap.vue?vue&type=template&id=47578dd2&scoped=true"
import script from "./bottomMap.vue?vue&type=script&lang=js"
export * from "./bottomMap.vue?vue&type=script&lang=js"
import style0 from "./bottomMap.vue?vue&type=style&index=0&id=47578dd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47578dd2",
  null
  
)

export default component.exports